import type { AvaliacaoDeliveryItem } from "../../../services/avaliacaoDelivery"

// CSV no padrão do Excel em português: separador ";" e BOM para manter os acentos.
const SEP = ";"
const EOL = "\r\n"
const BOM = "﻿"

const CABECALHO = ["Data", "Cliente", "Telefone", "Nota", "Comentário", "Pedido"]

function celula(valor: string | number | null | undefined): string {
    if (valor == null) return ""
    const texto = String(valor).replace(/\r?\n/g, " ")
    return /[";]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto
}

function formatarData(ms: number | null): string {
    if (ms == null) return ""
    return new Date(ms).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    })
}

export function gerarCsvAvaliacoes(avaliacoes: AvaliacaoDeliveryItem[]): string {
    const linhas = avaliacoes.map(a =>
        [
            formatarData(a.dataHora),
            a.clienteNome,
            a.telefoneCliente,
            a.nota,
            a.comentario,
            a.idPedido,
        ]
            .map(celula)
            .join(SEP)
    )
    return BOM + [CABECALHO.join(SEP), ...linhas].join(EOL)
}

export function baixarCsvAvaliacoes(avaliacoes: AvaliacaoDeliveryItem[], nomeArquivo: string) {
    const blob = new Blob([gerarCsvAvaliacoes(avaliacoes)], { type: "text/csv;charset=utf-8" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = nomeArquivo
    a.click()
    URL.revokeObjectURL(url)
}
